(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('LogisticsPlannerController', LogisticsPlannerController);

    LogisticsPlannerController.$inject = [
        '$templateCache',
        '$scope',
        'ordersService',
        '$rootScope',
        '$window',
        'ModalService',
        'fleet',
        'userService',
        'preferences',
        '$state',
        '$filter',
        'genericDataService',
        'simpleModalService',
        '$q',
        'common'
    ];

    /* jshint maxstatements:false, maxparams:false */
    function LogisticsPlannerController(
        $templateCache,
        $scope,
        ordersService,
        $rootScope,
        $window,
        ModalService,
        fleet,
        userService,
        preferences,
        $state,
        $filter,
        genericDataService,
        simpleModalService,
        $q,
        common
    ) {

        var splitStopTemplate = $templateCache.get('app/views/modals/splitStopTemplate.html');
        var assignDriverTemplate = $templateCache.get('app/views/modals/assignDriverTemplate.html');

        var templates = {
            accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/logisticsPlanner/actionsTemplate.html'),
            rowTemplate: $templateCache.get('app/views/tablesTemplates/logisticsPlanner/rowTemplate.html'),
            rowTemplateDiv: $templateCache.get('app/views/tablesTemplates/logisticsPlanner/rowTemplateDiv.html'),
            choferCellTemplate: $templateCache.get('app/views/tablesTemplates/activeOrders/choferCellTemplate.html'),
            statusCellTemplate:$templateCache.get('app/views/tablesTemplates/logisticsPlanner/statusCellTemplate.html'),
            clienteCellTemplate: $templateCache.get('app/views/tablesTemplates/activeOrders/clienteCellTemplate.html'),
            //drecogidaCellTemplate: 
            //    $templateCache.get('app/views/tablesTemplates/activeOrders/dRecogidaCellTemplate.html'),
            //dentregaCellTemplate: 
            //    $templateCache.get('app/views/tablesTemplates/activeOrders/dEntregaCellTemplate.html'),
            dentregaCellTemplate: 
                $templateCache.get('app/views/tablesTemplates/generic/ubicacionEntTemplate.html'),
            drecogidaCellTemplate: 
                $templateCache.get('app/views/tablesTemplates/generic/ubicacionRecTemplate.html'),
        };

        var userConfig = null;

        var paginationOptions = {
            pageNumber: 1,
            pageSize: 25,
			sort: { field: 'date', direction: 'desc' }
        };
        var sorting = {
			field: 'date',
			direction: 'desc'
        };

        var stdColumns = [
            {
                field: 'insurerId',
                displayName: '',
                width: 35,
                resizable: true,
                cellTemplate: templates.clienteCellTemplate,
                enableHiding: false
            },
            {
                field: 'state',
                displayName: '',
                minWidth: 40,
                maxWidth: 100,
                resizable: true,
                cellTemplate: templates.statusCellTemplate,
                sortingAlgorithm: function(stateA, stateB, rowA, rowB) { 
                    if(stateA === stateB){
                        if(rowA.entity.stateTime === rowB.entity.stateTime){
                            return 0;
                        } else if(rowA.entity.stateTime > rowB.entity.stateTime){
                            return 1;
                        } else{
                            return -1;
                        } 
                    }else if(stateA > stateB){
                        return 1;
                    }else{
                        return -1;
                    }
                }
            },
            {
                field: 'expediente',
                displayName: 'Expediente',
                minWidth: 90,
                maxWidth: 100,
                resizable: true
            },
            
            {
                field: 'date',
                displayName: 'Fecha',
                minWidth: 120,
                maxWidth: 125,
                cellFilter: 'date: "dd/MM/yyyy HH:mm"',
                resizable: true,
                sort: { priority: 1, direction: 'desc' }
            },
            {
                field: 'plate',
                displayName: 'Matrícula',
                minWidth: 80,
                maxWidth: 100,
                resizable: true,
            },            
            {
                field: 'restanteLog',
                displayName: 'Restante',
                minWidth: 80,
                maxWidth: 100,
                resizable: true,
                cellFilter: 'timeFormat'
            },
            {
                field: 'pickupAddress',
                displayName: 'Dirección de recogida',
                minWidth: 130,
                resizable: true,
                cellClass: 'overflow',
                cellFilter: 'capitalize',
                cellTemplate: templates.drecogidaCellTemplate,
                sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
                    if (rowA.entity.pickupTown === rowB.entity.pickupTown) {
                        return 0;
                    }
                    else if (rowA.entity.pickupTown > rowB.entity.pickupTown) {
                        return 1;
                    } else {
                        return -1;
                    }
                }
            },
            {
                field: 'deliveryAddress',
                displayName: 'Dirección de entrega',
                minWidth: 130,
                resizable: true,
                cellClass: 'overflow',
                cellFilter: 'capitalize',
                cellTemplate: templates.dentregaCellTemplate,
                sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
                    if (rowA.entity.pickupTown === rowB.entity.pickupTown) {
                        return 0;
                    }
                    else if (rowA.entity.deliveryTown > rowB.entity.deliveryTown) {
                        return 1;
                    } else {
                        return -1;
                    }
                }
            },
            {
                field: 'brand',
                displayName: 'Marca',
                minWidth: 60,
                maxWidth: 100,
                resizable: true,
                cellFilter: 'capitalize',
            },
            {
                field: 'model',
                displayName: 'Modelo',
                minWidth: 65,
                maxWidth: 100,
                resizable: true,
                cellFilter: 'capitalize',
            },
            {
                field: 'fleetId',
                displayName: 'Vehículo',
                minWidth: 45,
                maxWidth: 90,
                resizable: true,
                cellFilter: 'capitalize',
            },
            {
                field: 'assignedDriver',
                displayName: 'Chofer',
                width: 85,
                resizable: true,
                cellFilter: 'capitalize',
                cellTemplate: templates.choferCellTemplate
            },
            {
                name: 'acciones',
                displayName: 'Acciones',
                width: 150,
                resizable: true,
                cellClass: 'overflow',
                cellTemplate: templates.accionesCellTemplate,
                enableHiding: false,
                enableSorting: false
            },{
                field: 'groupDate',
                grouping: { groupPriority: 0 },
                enableHiding: false,
                sort: { priority: 0, direction: 'asc' },
                visible: false
            }
        ];
        var divColumns = [
            {
                field: 'numService',
                displayName: 'Tramo',
                width: 60,
                resizable: true,
            },
            {
                field: 'insurerId',
                displayName: '',
                width: 30,
                resizable: true,
                cellTemplate: templates.clienteCellTemplate,
                enableHiding: false
            },
            {
                field: 'state',
                displayName: '',
                minWidth: 40,
                maxWidth: 100,
                resizable: true,
                cellTemplate: templates.statusCellTemplate,
                sortingAlgorithm: function(stateA, stateB, rowA, rowB) { 
                    if(stateA === stateB){
                        if(rowA.entity.stateTime === rowB.entity.stateTime){
                            return 0;
                        } else if(rowA.entity.stateTime > rowB.entity.stateTime){
                            return 1;
                        } else{
                            return -1;
                        } 
                    }else if(stateA > stateB){
                        return 1;
                    }else{
                        return -1;
                    }
                }
            },
            {
                field: 'expediente',
                displayName: 'Expediente',
                minWidth: 90,
                maxWidth: 130,
                resizable: true
            },
            
            {
                field: 'date',
                displayName: 'Fecha',
                minWidth: 70,
                maxWidth: 130,
                cellFilter: 'date: "dd/MM/yyyy HH:mm"',
                resizable: true,
                sort: { priority: 1, direction: 'desc' }
            },
            {
                field: 'plate',
                displayName: 'Matrícula',
                minWidth: 80,
                maxWidth: 100,
                resizable: true,
            },
            
            {
                field: 'restanteLog',
                displayName: 'Restante',
                minWidth: 80,
                maxWidth: 100,
                resizable: true,
                cellFilter: 'timeFormat'
            },
            {
                field: 'pickupAddress',
                displayName: 'Dirección de recogida',
                minWidth: 160,
                resizable: true,
                cellClass: 'overflow',
                cellFilter: 'capitalize',
                cellTemplate: templates.drecogidaCellTemplate,
                sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
                    if (rowA.entity.pickupTown === rowB.entity.pickupTown) {
                        return 0;
                    }
                    else if (rowA.entity.pickupTown > rowB.entity.pickupTown) {
                        return 1;
                    } else {
                        return -1;
                    }
                }
            },
            {
                field: 'deliveryAddress',
                displayName: 'Dirección de entrega',
                minWidth: 160,
                resizable: true,
                cellClass: 'overflow',
                cellFilter: 'capitalize',
                cellTemplate: templates.dentregaCellTemplate,
                sortingAlgorithm: function (stateA, stateB, rowA, rowB) {
                    if (rowA.entity.pickupTown === rowB.entity.pickupTown) {
                        return 0;
                    }
                    else if (rowA.entity.deliveryTown > rowB.entity.deliveryTown) {
                        return 1;
                    } else {
                        return -1;
                    }
                }
            },
            {
                field: 'brand',
                displayName: 'Marca',
                minWidth: 60,
                maxWidth: 100,
                resizable: true,
                cellFilter: 'capitalize',
            },
            {
                field: 'model',
                displayName: 'Modelo',
                minWidth: 65,
                maxWidth: 100,
                resizable: true,
                cellFilter: 'capitalize',
            },
            {
                field: 'fleetId',
                displayName: 'Vehículo',
                minWidth: 75,
                maxWidth: 90,
                resizable: true,
                cellFilter: 'capitalize',
            },
            {
                field: 'assignedDriver',
                displayName: 'Chofer',
                width: 85,
                resizable: true,
                cellFilter: 'capitalize',
                cellTemplate: templates.choferCellTemplate
            },
            {
                name: 'acciones',
                displayName: 'Acciones',
                width: 150,
                resizable: true,
                cellClass: 'overflow',
                cellTemplate: templates.accionesCellTemplate,
                enableHiding: false,
                enableSorting: false
            },{
                field: 'divididaId',
                grouping: { groupPriority: 0 },
                enableHiding: false,
                sort: { priority: 0, direction: 'asc' },
                visible: false
            }
        ];

        var vm = this;
        
        vm.onDateRangeChange = onDateRangeChange;
        vm.dateRange = $.extend({}, common.defaultDateRangePickerOptions);
        vm.rowCount = 0;
        vm.firstLoaded = false;
        vm.searchText = '';
        vm.clearSearcher = clearSearcher;
        vm.refreshData = refreshData;
        vm.loading = false;
        $scope.gridData = [];

        vm.preferences = preferences;
        vm.gridOptions = {

            rowTemplate: templates.rowTemplate,
            
			enableGridMenu: true,
            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,

            paginationPageSizes: [25, 50, 75],
            paginationPageSize: 25,
            useExternalPagination: true,
            useExternalSorting: true,
            
            virtualizationThreshold: 200, 

            //Row selection
            enableRowHeaderSelection: true,
            enableGroupHeaderSelection: false,
            enableRowSelection: false,
            enableSelectAll: true,
            multiSelect: true,
            enableColumnResizing: true,

            rowHeight: 26,

            primaryKey: 'orderId', 
            columnDefs: stdColumns,
            data: 'gridData',
            onRegisterApi: function (gridApi) {
				vm.gridApi = gridApi;
                //vm.gridApi.grid.options.enableExpandAll = false;
                
                vm.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if(sortColumns.length > 1){
                        sorting.field = sortColumns[1].field;
                        sorting.direction = sortColumns[1].sort.direction;
                    }else{
                        sorting = {field: null, direction: null};
                    }
                    getOrdersData();
                });
                vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;
					getOrdersData();

                });
                vm.gridApi.core.on.columnVisibilityChanged( $scope, function( changedColumn ){
                    //saveColumnsVisibilityState();
                });

                //vm.gridApi.grid.registerDataChangeCallback(function () {
                //    if (!common.isNullOrUndefined(vm.gridApi.treeBase))
                //        vm.gridApi.treeBase.expandAllRows();
                //});
			}
        };

        vm.data = null;

        vm.frequencyFields = [
            'date','pickupAddress','deliveryAddress','plate','brand','model','expediente','operatorId'
        ];
        
        vm.appliedFilters = [];
        vm.showDiv = false;

        vm.getOrdersData = getOrdersData;
        vm.showAssignDriver = showAssignDriver;
        vm.assignOperatorToOrder = assignOperatorToOrder;
        vm.getBrandLogo = getBrandLogo;
        vm.getColorEstado = getColorEstado;
        vm.getEstado = getEstado;
        vm.goToEdit = goToEdit;
        vm.selectAll = selectAll;
        vm.clearAll = clearAll;
        vm.invertSelection = invertSelection;
        vm.selectOrClear = selectOrClear;
        vm.split = split;
        vm.groupHeaderContent = groupHeaderContent;
        vm.join = join;
        vm.toggleDiv= toggleDiv;
        vm.getRowEntity = getRowEntity;
        vm.checkNextToJoin = checkNextToJoin;
        vm.getIconoOrden = getIconoOrden;
		vm.deleteSearchData = deleteSearchData;

        (function () {
            //userService.loadWithDefaults() //initialize user options
            //    .then(function (data) { userConfig = data; });
            userConfig = userService.userData;
            vm.getOrdersData();
        })();

        function getOrdersData() {
            if(vm.showDiv){
                return getOrdersDiv();
            } else{
                return getOrders();
            }
        }

        vm.test = test;
        function test(a,b,c){
            //console.log(a,b,c);
        }


        function getOrders(){
            var deferred = $q.defer();

            var skip = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            var take = paginationOptions.pageSize;
            vm.refreshing = true;
            ordersService.getLogPlannerOrders(skip, take, sorting, vm.appliedFilters, 0, vm.frequencyFields, vm.searchText, vm.dateRange.fromDate, vm.dateRange.toDate)
                .then(function (result) {
                    vm.data = result.data.list;

                    vm.data.forEach(element => {
                        var d = new Date(element.date).setHours(0,0,0,0);
                        element.groupDate =$filter('date')(d, 'dd/MM/yyyy');
                    });

                    $scope.gridData = vm.data;
                    vm.gridOptions.totalItems = result.data.count;
                    vm.rowCount = vm.gridOptions.totalItems;
                    vm.firstLoaded = true;
                    vm.gridOptions.columnDefs = stdColumns;
                    vm.gridOptions.rowTemplate = templates.rowTemplate;
                    
                    vm.refreshing = false;
                    vm.showDiv = false;
                    
                    deferred.resolve(result);
                }, function(result){ deferred.reject(result);}
            );

            return deferred.promise;
        }

        function getOrdersDiv(){
            var deferred = $q.defer();
            var skip = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            var take = paginationOptions.pageSize;
            vm.refreshing = true;
            ordersService.getLogPlannerOrdersDiv(skip, take, sorting, 
                vm.appliedFilters, 0, 
                vm.frequencyFields, vm.searchText)
                .then(function (result) {
                    vm.data = result.data.list;

                    var fData = [];

                    for(var i = 0; i < vm.data.length; i++){
                        if(vm.data[i].dividida !== true){
                            if(vm.data[i].divididaId === null){
                                vm.data[i].divididaId = vm.data[i].orderId;
                            }
                            fData.push(vm.data[i]);
                        }
                    }

                    $scope.gridData = fData;

                    vm.gridOptions.totalItems = result.data.count;
                    vm.gridOptions.columnDefs = divColumns;
                    vm.gridOptions.rowTemplate = templates.rowTemplateDiv;

                    vm.refreshing = false;
                    vm.showDiv = true;
                    deferred.resolve(result);
                }, function(result){ deferred.reject(result);}
            );
            return deferred.promise;
        }

        function getIconoOrden(tipo) {
            return userConfig.orders.iconoOrden[tipo] || 'undefined';
        }

        function toggleDiv(){
            if(vm.showDiv){
                getOrders();
            } else {
                getOrdersDiv();
            }
        }

        function getRowEntity(id){
            return $filter('filter')(vm.data, { orderId : id})[0];
        }

        function goToEdit(id, row) {
            var orderId = id;
			vm.focusedRow = orderId;
			var allOrdersOpen = null;
			if ($rootScope.tabManager.indexOfName('ordenes') !== -1) {
				allOrdersOpen = true;
			}
			$state.go('flota.ordenes.editar', { 'id': orderId, 'allOrdersOpen': allOrdersOpen });
        }

        function showAssignDriver(orderId, order) { //MODAL
            vm.operatorsList = [];
			fleet.getAssignableOperators(orderId).then(function (data) {
                vm.operatorsList = data;
            });

            ModalService.showModal({
                template: assignDriverTemplate,
                controller:
                function (close) {
                    var modal = this;
                    modal.parentScope = vm;

                    modal.companyName = order.clientName;
                    modal.companySrc = vm.getBrandLogo(order.insurerId);
                    modal.tMedio = order.vehicleType;

					modal.cancel = function () {
                        $rootScope.blurry = false;
                        close();
                    };
                },
                controllerAs: 'modal'
            });
        }
		function assignOperatorToOrder(orderId, operatorId, state, modal, confirm) {
			if (state !== 100 || confirm ) {
				vm.blurGrid = true;
				ordersService.assignToOperator(operatorId, orderId).then(function (result) {
					vm.modal1 = false;
					vm.blurGrid = false;
					vm.getOrdersData().then(function () {
                        if(modal){
                            modal.cancel();
                        }
					});
                });
            }
        }
        function getBrandLogo(tipo) {
            if(!userConfig) { return null; }
            if(tipo === null){ return null; }
            return userConfig.brands.insurance[tipo] || null;
        }
        function getColorEstado(estado) {
            return preferences.prefs.getStateColor(estado) || 'undefined';
        }

        function getEstado(tipo) {
            if(!userConfig) { return null; }
            if(tipo === null){ return null; }
            return userConfig.literals.estados[tipo] || '-';
        }

        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }
        function clearAll() {
            vm.gridApi.selection.clearSelectedRows();
        }
        function invertSelection() {
            var selected = vm.gridApi.selection.getSelectedRows();

            vm.selectAll();

            for (var i = 0; i < selected.length; i++) {
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }
        function selectOrClear() {
            if (vm.gridApi.selection.getSelectAllState()) {
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }

        function split(order){

            if(order.state !== 0){
                simpleModalService.infoModal('No se puede dividir una orden si no está pendiente de asignar.');
                return;
            }

            ModalService.showModal({
                template: splitStopTemplate,
                controller: function(close){
                    var modal = this;
                    
                    modal.parada = {
                        tipoUbicacion : 'D'
                    };

                    modal.tipos = {
                        list: [
                            { id: 'D', nombre: 'Dirección', showField: false },
                            { id: 'B', nombre: 'Base', showField: true },
                            { id: 'T', nombre: 'Taller', showField: true },
                            { id: 'C', nombre: 'Colaboradores', showField: true }
                        ]
                    };
                    modal.bases = { list: [] };
                    modal.talleres = { list: [] };
                    modal.colaboradores = { list: [] };
                    modal.paises = { list: [] };
                    modal.provincias = { list: [] };
                    modal.poblaciones = { list: [] };
                    modal.zonas = { list: [] };

                    modal.onBaseSelected = onBaseSelected;
                    modal.onTallerSelected = onTallerSelected;
                    modal.onPaisChanged = onPaisChanged;
                    modal.onProvChanged = onProvChanged;
                    modal.onColaboradorSelected = onColaboradorSelected;

                    (function(){
                        initialize();
                    })();

                    function initialize(){
                        modal.bases.loading = true;
                        genericDataService.getBases()
                            .then(function (res) {
                                modal.bases.loading = false;
                                modal.bases.list = res;
                            });

                        modal.talleres.loading = true;
                        genericDataService.getTalleres()
                            .then(function (res) {
                                modal.talleres.loading = false;
                                modal.talleres.list = res;
                            });

                        modal.colaboradores.loading = true;
                        genericDataService.getColaboradores()
                            .then(function (res) {
                                modal.colaboradores.loading = false;
                                modal.colaboradores.list = res;
                            });

                        modal.paises.loading = true;
                        genericDataService.getPaises(null)
                            .then(function (res) {
                                modal.paises.loading = false;
                                modal.paises.list = res;
                            });
                    }

                    function onBaseSelected(){
                        /*jshint maxcomplexity:false */
                        var baseId = modal.parada.baseId;
                        if(baseId === null || modal.bases.list === null){ return; }
                        var base = $filter('filter')(modal.bases.list, {id: baseId})[0];
                        if(base === null) {return;}
                        
                        modal.parada.paisId = base.paisId || null;
                        modal.parada.pais = base.pais || null;
                        modal.parada.provinciaId = base.provinciaId || null;
                        modal.parada.provincia = base.provincia || null;
                        modal.parada.poblacionId = base.poblacionId || null;
                        modal.parada.poblacion = base.poblacion || null;
                        modal.parada.CP = base.cp || null;
                        modal.parada.direccion = base.direccion || null;
                        modal.parada.latitud = base.latitud || null;
                        modal.parada.longitud = base.longitud || null;

                        modal.parada.entidadId = modal.parada.baseId;
                        modal.parada.descripcion = base.nombre;
                    }

                    function onTallerSelected(){
                        /*jshint maxcomplexity:false */
                        var tallerId = modal.parada.tallerId;
                        if(tallerId === null || modal.talleres.list === null){ return; }
                        var taller = $filter('filter')(modal.talleres.list, {id: tallerId})[0];
                        if(taller === null) {return;}
                        
                        modal.parada.paisId = taller.paisId || null;
                        modal.parada.pais = taller.pais || null;
                        modal.parada.provinciaId = taller.provinciaId || null;
                        modal.parada.provincia = taller.provincia || null;
                        modal.parada.poblacionId = taller.poblacionId || null;
                        modal.parada.poblacion = taller.poblacion || null;
                        modal.parada.CP = taller.cp || null;
                        modal.parada.direccion = taller.direccion || null;
                        modal.parada.latitud = taller.latitud || null;
                        modal.parada.longitud = taller.longitud || null;
                        
                        modal.parada.entidadId = modal.parada.tallerId;
                        modal.parada.descripcion = taller.nombre;
                    }

                    function onColaboradorSelected(){
                        /*jshint maxcomplexity:false */
                        var colabId = modal.parada.colabId;
                        if(colabId === null || modal.colaboradores.list === null){ return; }
                        var colab = $filter('filter')(modal.colaboradores.list, {id: colabId})[0];
                        if(colab === null) {return;}
                        
                        modal.parada.paisId = colab.paisId || null;
                        modal.parada.pais = colab.pais || null;
                        modal.parada.provinciaId = colab.provinciaId || null;
                        modal.parada.provincia = colab.provincia || null;
                        modal.parada.poblacionId = colab.poblacionId || null;
                        modal.parada.poblacion = colab.poblacion || null;
                        modal.parada.CP = colab.cp || null;
                        modal.parada.direccion = colab.direccion || null;
                        modal.parada.latitud = colab.latitud || null;
                        modal.parada.longitud = colab.longitud || null;
                        
                        modal.parada.entidadId = modal.parada.colabId;
                        modal.parada.descripcion = colab.nombre;
                    }

                    function onPaisChanged(){
                        var pais = modal.parada.paisId;
                        getProvincias(null, pais);
                    }

                    function onProvChanged(){
                        var provincia = modal.parada.provinciaId;
                        getPoblaciones(null, provincia);
                    }

                    function getProvincias(clientId, pais){
                        if (pais == null) {
                            modal.provincias.list = null;
                        } else {
                            modal.provincias.loading = true;
                            genericDataService.getProvinces(clientId, pais)
                                .then(function (res) {
                                    modal.provincias.loading = false;
                                    modal.provincias.list = res;
                                });
                        }
                    }

                    function getPoblaciones(clientId, provincia){
                        if (provincia == null) {
                            modal.poblaciones.list = null;
                        }
                        else {
                            modal.poblaciones.loading = true;
                            genericDataService.getPopulations(clientId, provincia)
                                .then(function (res) {
                                    modal.poblaciones.loading = false;
                                    modal.poblaciones.list = res;
                                });
                        }
                    }

                    modal.close = function(result) {
                        close(result);
                    };
                },
                controllerAs: 'modal'
            }).then(function(modal) {
                modal.close.then(function(result) {
                    /*jshint maxcomplexity:false */

                    if(!result) { return; } //Close

                    ordersService.splitOrder(order.orderId, result).then(function(){
                        getOrdersData();
                    });
                });
            });
        }
    
        function join(order){
            if(!order){return;}
            var index = $scope.gridData.indexOf(order);
            var order2 = $scope.gridData[index+1];
            if(!order2){return;}

            if(order.state !== 0 || order2.state !== 0){
                simpleModalService.infoModal('No se puede dividir una orden si no está pendiente de asignar.');
                return;
            }
            
            ordersService.joinOrder(order.orderId, order2.orderId).then(function(){
                getOrdersData();
            });
        }

        function checkNextToJoin(order){
            var index = $scope.gridData.indexOf(order);
            var order2 = $scope.gridData[index+1];
            if(!order2){ return false; }
            return order2.divididaId === order.divididaId && order2.numService === order.numService+1;
        }

        function groupHeaderContent(row, cols){
            return row.treeNode.aggregations[0].groupVal;
		}

		function deleteSearchData() {
			vm.searchText = '';
        }

        function refreshData() {
            vm.refreshing = true;
            getOrdersData();
        }

        function clearSearcher() {
            vm.searchText = '';
            refreshData();
        }

        function onDateRangeChange() {
            refreshData();
        }
    } 
})();
